


























































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";

@Component
export default class LearningResourceTable extends Vue {
  @PropSync("resources") myResources!: Array<ILearningResourceInfo>; //all
  @Prop() existResources!: Array<ILearningResourceInfo>; //exist
  @Prop() getCheckedResources!: Array<ILearningResourceInfo>;
  checkedResources: Array<ILearningResourceInfo> = []; // все выбранные
  checkboxForSelectAll: boolean = false;

  get screenWidth() {
    return window.innerWidth;
  }

  getResourceType(resource: string) {
    if (resource === "course") {
      return this.$tc(this.$translate.Course);
    } else if (resource === "video") {
      return this.$tc(this.$translate.Video);
    } else if (resource === "webinar") {
      return this.$tc(this.$translate.Webinar);
    } else if (resource === "course2") {
      return "SCORM";
    }
  }

  checkResource(resource: ILearningResourceInfo) {
    return this.checkedResources.includes(resource);
  }

  setupResource(resource: ILearningResourceInfo) {
    this.checkedResources.includes(resource)
      ? (this.checkedResources = this.checkedResources.filter(
          el => el !== resource
        ))
      : this.checkedResources.push(resource);
  }

  selectAll() {
    if (!this.checkboxForSelectAll) {
      this.checkedResources = [];
    } else {
      this.checkedResources = this.myResources;
    }
  }

  getExistResources() {
    if (this.existResources) {
      this.checkedResources = this.existResources;
    }
  }

  mounted() {
    this.getExistResources();
    this.checkedResources = this.getCheckedResources;
  }

  @Watch("getCheckedResources")
  checkPropRes() {
    this.checkedResources = this.getCheckedResources;
  }

  @Watch("checkedResources")
  checkCheckedResources() {
    this.checkboxForSelectAll =
      this.checkedResources.length === this.myResources.length;

    this.$emit("getCheckedResources", this.checkedResources);
  }
}
